<template>
    <!-- 抽屉型 -->
    <popup ref="popup" :show.sync="openPop" :title="content.tit" :isShowScroll="false" :showClose="true">
        <div class="chat-drawer">
          <div v-if="tab && tab.length" class="tab-container">
                    <div v-for="(item, index) in tab" @click="switchTab(item)"
                        :class="['tab-wrapper', 'title-name', item.tabId === choosedTabId ? 'choosed' : '']">
                        {{ item.tabName }}
                    </div>
                </div>
                <div class="drawer-list-wrapper">
                    <div class="drawer-list" id="tab1">
                        <template v-if="isGroupType">
                            <div class="drawer-list-content" v-for="item in contentList">
                                <div class="drawer-item drawerList-body-head">
                                    <div class="left">
                                        <img :src="item.logo" alt="" class="logo">
                                        <div class="tit">{{ item.name }}</div>
                                    </div>
                                    <div class="right">
                                        <div class="status">{{ item.status }}</div>
                                    </div>
                                </div>
                                <drawer-item :list="item.subList" @chooseItem="chooseItem"></drawer-item>
                            </div>
                        </template>
                        <div v-else class="drawer-list-content">
                            <drawer-item :list="contentList" @chooseItem="chooseItem"></drawer-item>
                        </div>
                        <div class="drawer-list-bottom" v-if="hasNext || isShowLoading || showNoMore">
                            <span v-if="hasNext" @click="loadMore">点击加载更多订单</span>
                            <i v-else-if="isShowLoading" class="loading loading-s"></i>
                            <span v-else-if="showNoMore">暂无更多订单</span>
                        </div>
                    </div>
                </div>
        </div>
    </popup>
</template>

<script>

import Popup from '@/components/Popup';
import DrawerItem from './DrawerItem';
import globalWin from '@/utils/globalWin.ts';
import transfer from '@/utils/xmlMsg/robotCardXml';
import ajaxGetGoodsList from '../fetchGoodsList';
export default {
  components: {
    Popup,
    DrawerItem,
  },
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
    to: {
      type: Object,
      default() {
        return {};
      },
    },
    wpaDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    globalData: {
      type: Object,
      default() {
        return;
      },
    },
  },
  watch: {
    'globalData.reception': {
      handler(val) {
        if (!val.extuin) {
          this.openPop = false;
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      openPop: true, // 打开弹窗
      content: {},  // 消息内容
      contentList: [], // 列表
      tab: [], // tab列表
      choosedTabId: 0, // 选中的tab下标
      hasNext: false, // 是否有下一页
      isGroupType: true, // 是否聚合型
      isShowLoading: false, // 是否展示loading
      currentPage: 0, // 当前页码
      showNoMore: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.openPop = true;
    }, 400);
    // eslint-disable-next-line max-len
    const { content: { content: { contentData: { contentList = [], tab = [], currentPage } } } } = this.message; // 消息解构一下，避免渲染的时候字段层级太深
    this.content = this.message?.content?.content;
    this.hasNext = this.content.contentData?.hasNext;
    this.contentList = contentList;
    this.tab = tab;
    this.choosedTabId = tab[0] && tab[0].tabId;
    this.isGroupType = this.content.templateId === 5;
    this.currentPage = currentPage;
  },
  methods: {
    switchTab(item) {
      // 选中当前tab则不处理
      if (item.tabId === this.choosedTabId) {
        return;
      }
      this.choosedTabId = item.tabId;
      this.contentList = [];
      this.currentPage = 0;
      this.loadMore();
    },
    chooseItem(item) {
      this.openPop = false;
      globalWin.sendQDXMLMessage({
        qdxml: {
          content: transfer(item),
          brief: '企点结构化消息',
        },
      }, null, {
        robot_ctrl: {
          str_ext2robot: JSON.stringify({ ...item, extRobotType: 2 }),
        },
      });
    },
    async loadMore() {
      this.hasNext = false;
      this.isShowLoading = true;
      const { content: { content: { questionId = '', domain = '', intent = '', pageSize } } } = this.message;
      // eslint-disable-next-line camelcase, no-unused-vars
      const { crm: { msg_webim_extra_data: { bytes_wpaid = '', uint64_robotid = '' }, str_session_id } } = this.message;
      const params = {
        questionId,
        domain,
        intent,
        tabId: this.choosedTabId,
        pageSize,
        currentPage: this.currentPage + 1, // 传下一页
        robotId: uint64_robotid,
        sessionId: str_session_id,
        wpaId: bytes_wpaid,
        corpUin: this.wpaDetail.kfuin,
        visitId: this.to.user_id,
        channelType: 3,
      };
      const response = await ajaxGetGoodsList(params);
      const { code, msg, data } = response;
      this.isShowLoading = false;
      if (+code === 0) {
        // 先判断下为空的情况
        if (!data.contentData) {
          this.showNoMore = true;
          this.hasNext = false;
          return;
        }
        const { contentData: { contentList = [], hasNext, currentPage } } = data;
        this.contentList = this.contentList.concat(contentList);
        this.currentPage = currentPage;
        this.hasNext = hasNext;
        this.showNoMore = !hasNext;
      } else {
        this.$Toast(msg || '更多数据加载失败');
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import './common.less';
// 抽屉列表
.chat-drawer {
    // height: 471px;
    min-height: 180px;
    max-height: 326px;
    // box-shadow: 0 1px 10px 0 #e1e6f0;
    background-color: #ffffff;
    overflow: hidden;
    border-radius: 6px;
    z-index: 100;
    transform-origin: 0px 0px;
    opacity: 1;
    transform: scale(1, 1);

    /* 此处的图层要大于蒙层 */
    .drawer-head {
        background: #ffffff;
        border-radius: 8px 8px 0px 0px;
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 48px;
        height: 48px;
        text-align: center;
        color: #262d3d;

        .icon-arrow-down {
            position: absolute;
            right: 16px;
            top: 16px;
            font-size: 30px;
            // background-image: url(../image/arrow-down-black.png);
            // background-size: 100% 100%;
            display: inline-block;
            width: 23px;
            height: 16px;
        }
    }

    .tab-container {
            display: flex;
            padding-top: 10px;
            overflow-x: auto;

            .tab-wrapper {
                width: auto;
                min-width: 115px;
                display: flex;
                justify-content: center;
                cursor: pointer;
                font-family: PingFang SC;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #262d3d;
                height: 20px;
                padding-bottom: 7px;
                color: rgb(38, 45, 61);
                // border-bottom: 2px solid rgb(74, 112, 255);

            }

            .choosed {
                color: #4a70ff;
                border-bottom: 3px solid #4a70ff;
            }
        }
        .drawer-list-wrapper {
            max-height: 267px;
            overflow: auto;
            .drawer-list {
                .drawer-list-content {
                    overflow: hidden; //去除因为竖直滚动条导致的横向滚动条
                    width: 100%;

                    .drawer-item {
                        // width: 100%;
                        // height: 36px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        color: #262d3d;
                        font-size: 13px;
                        cursor: pointer;

                        .drawer-item-text {
                            height: 36px;
                            line-height: 36px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }

                    .drawerList-body-head {
                        display: flex;
                        justify-content: space-between;
                        padding: 10px 16px;
                        background: #f8f9fb;
                        box-sizing: border-box;

                        .left {
                            display: flex;
                            font-family: PingFang SC;
                            font-style: normal;
                            font-weight: normal;
                            font-size: 14px;
                            line-height: 20px;
                            color: #262d3d;

                            .logo {
                                width: 20px;
                                height: 20px;
                                margin-right: 6px;
                            }
                        }

                        .right {
                            font-family: PingFang SC;
                            font-style: normal;
                            font-weight: normal;
                            font-size: 12px;
                            line-height: 18px;
                            color: #78849e;
                        }
                    }
                }

                .drawer-list-bottom {
                    position: relative;
                    font-family: PingFang SC;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    color: #a1abc2;
                    cursor: pointer;
                }
            }

            &:first-child {
                display: block;
            }
        }
}

.item-logo {
    width: 100%;
    height: 100%;
}
</style>
